/* eslint-disable */
// /src/pages/HomePage.jsx
import React, { useRef, useState, useEffect } from "react";
import styled, { css } from "styled-components";
import Container from "../components/Container";
import BottomNav from "../components/BottomNav";
import Header from "../components/Header";
import { useNavigate } from "react-router-dom";
import { imageDB } from "utils/imageDB";
import { getPublishedOnce } from "../services/homeConfigService";
import FooterCompanyInfo from "components/FooterCompanyInfo";
import { AiOutlineLock } from "react-icons/ai";
import { useAppConfig } from "../context/AppConfigContext";
import { useDriverStatusContext } from "context/DriverStatusContext";
import { checkAndApplyAppUpdate } from "services/appVersionService";



/* ===== 세션 유틸 ===== */
const getSession = () => {
    try {
        return JSON.parse(localStorage.getItem("dhm.session") || "null");
    } catch {
        return null;
    }
};
const isGuestSession = (s) => !s || s.auth !== "user";

/* ===== 스타일 ===== */
const BG = styled.div`
  width: 100%;
  min-height: 100vh;
  background: #f9f9f9;
  display: flex;
  flex-direction: column;
`;

/* ===== Hero Slider ===== */
const HeroWrap = styled.div`
  position: relative;
  width: 100%;
  height: 280px;
  overflow: hidden;
  touch-action: pan-y;
  user-select: none;
`;
const Track = styled.div`
  display: flex;
  height: 100%;
  will-change: transform;
  transform: translateX(${(p) => `-${p.$index * 100}%`});
  transition: ${(p) => (p.$anim ? "transform .35s ease" : "none")};
`;
const Slide = styled.div`
  flex: 0 0 100%;
  width: 100%;
  height: 100%;
  overflow: hidden;
  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    display: block;
  }
`;
const HeroGradient = styled.div``;

const HeroText = styled.div`
  position: absolute;
  top: 40px;
  left: 24px;
  color: #fff;
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.25);
  h1 {
    font-size: 22px;
    font-weight: 700;
    margin: 0;
  }
  p {
    margin-top: 8px;
    font-size: 16px;
    font-weight: 600;
  }
`;

const Dots = styled.div`
  position: absolute;
  bottom: 10px;
  left: 0;
  right: 0;
  display: flex;
  justify-content: center;
  gap: 6px;
`;
const Dot = styled.span`
  width: 8px;
  height: 8px;
  border-radius: 999px;
  display: inline-block;
  background: ${(p) =>
        p.$active ? "rgba(255,255,255,.95)" : "rgba(255,255,255,.45)"};
`;

/* ===== Top Sheet / Cards ===== */
const TopSheet = styled.div`
  position: relative;
  margin-top: -24px;
  background: #f9f9f9;

  padding: 16px;
  margin-bottom: 80px;
`;
const Grabber = styled.div`
  width: 48px;
  height: 6px;
  border-radius: 999px;
  background: #d1d5db;
  margin: 0 auto 16px;
`;
const SectionTitle = styled.h2`
  font-size: 18px;
  font-weight: 700;
  color: var(--color-text, #5a3a2e);
  margin: 0 0 12px;
`;
const FeatureGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 12px;
`;

const FeatureCardRoot = styled.button`
  position: relative;
  display: flex;
  flex-direction: column;
  gap: 6px;
  padding: 16px;
  border: none;
  border-radius: 16px;
  background: ${(p) => (p.$disabled ? "#f3f4f6" : "#fff")};
  box-shadow: ${(p) =>
        p.$disabled ? "none" : "0 1px 6px rgba(0, 0, 0, 0.05)"};
  cursor: pointer;
  text-align: left;
  overflow: hidden;
  min-height: 120px;
  color: inherit;
  ${(p) =>
        p.$tall &&
        css`
      min-height: 180px;
    `}
  &:active {
    transform: translateY(1px);
  }
  &:hover {
    background: ${(p) => (p.$disabled ? "#f3f4f6" : "#f9fafb")};
    color: inherit;
  }

  .title {
    font-size: 17px;
    font-weight: 800;
    letter-spacing: -0.2px;
    color: ${(p) => (p.$disabled ? "#9ca3af" : "#111")};
  }
  .subtitle {
    font-size: 13px;
    line-height: 1.3;
    font-weight: 500;
    white-space: pre-line;
    color: ${(p) => (p.$disabled ? "#cbd5e1" : "#9aa0a6")};
  }
`;

const LockBadge = styled.div`
  position: absolute;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  pointer-events: none;
`;

const LockCircle = styled.div`
  width: 56px;
  height: 56px;
  border-radius: 999px;
  background: rgba(148, 163, 184, 0.18);
  display: grid;
  place-items: center;
  box-shadow: 0 2px 6px rgba(15, 23, 42, 0.18);
  color: #111827;
`;

// 잠금 이미지 전용 스타일
const LockImg = styled.img`
  width: 50px;
  height: auto;
  object-fit: contain;
  display: block;
`;

// 이미지 썸네일
const Thumb = styled.div`
  position: absolute;
  right: 8px;
  bottom: 0;
  border-radius: 10px;
  overflow: hidden;
  pointer-events: none;

  img {
    display: block;
    max-width: 130px;
    height: auto;
    object-fit: contain;
    transform: scale(${(p) => p.$scale || 1});
    transform-origin: bottom right;
    filter: ${(p) => (p.$disabled ? "grayscale(1)" : "none")};
    opacity: ${(p) => (p.$disabled ? 0.45 : 1)};
  }
`;

const Thumb3 = styled.div`
  position: absolute;
  right: 8px;
  bottom: 0;
  border-radius: 10px;
  overflow: hidden;
  pointer-events: none;

  img {
    display: block;
    max-width: 100px;
    height: auto;
    object-fit: contain;
    transform: scale(${(p) => p.$scale || 1});
    transform-origin: bottom right;
    filter: ${(p) => (p.$disabled ? "grayscale(1)" : "none")};
    opacity: ${(p) => (p.$disabled ? 0.45 : 1)};
  }
`;

const Thumb2 = styled.div`
  position: absolute;
  right: -50px;
  bottom: 0;
  width: ${(p) => p.$w}px;
  height: ${(p) => p.$h}px;
  transform: translate(${(p) => p.$ox || 0}px, ${(p) => p.$oy || 0}px);
  border-radius: 10px;
  overflow: hidden;
  pointer-events: none;
  top: 5px;

  img {
    width: 100%;
    height: 100%;
    object-fit: contain;
    display: block;
    transform: scale(${(p) => p.$scale || 1});
    transform-origin: bottom right;
  }
`;


const UpdateBanner = styled.div`
  position: fixed;
  left: 0;
  right: 0;
  bottom: 56px; /* BottomNav 위에 붙이기 (필요하면 조정) */
  z-index: 999;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 8px 12px;
  background: rgba(15, 23, 42, 0.96);
  color: #f9fafb;
  font-size: 13px;
`;

const Spinner = styled.div`
  width: 16px;
  height: 16px;
  border-radius: 999px;
  border: 2px solid rgba(248, 250, 252, 0.4);
  border-top-color: #e5e7eb;
  animation: spin 0.7s linear infinite;

  @keyframes spin {
    to {
      transform: rotate(360deg);
    }
  }
`;


function FeatureCard({
    title,
    subtitle,
    onClick,
    img,
    tall,
    imgWidth,
    imgHeight,
    offsetX = 0,
    offsetY = 0,
    scale = 1,
    disabled = false,
    locked = false,
    lockImg,
}) {
    const w = imgWidth ?? (tall ? 116 : 68);
    const h = imgHeight ?? (tall ? 80 : 48);
    const rootDisabled = disabled || locked;

    return (
        <FeatureCardRoot
            onClick={onClick}
            $tall={tall}
            $disabled={rootDisabled}
            type="button"
        >
            <div className="title">{title}</div>
            {subtitle && <div className="subtitle">{subtitle}</div>}
            {img && (
                <Thumb
                    $w={w}
                    $h={h}
                    $ox={offsetX}
                    $oy={offsetY}
                    $scale={scale}
                    $disabled={rootDisabled}
                >
                    <img src={img} alt="" />
                </Thumb>
            )}
            {locked && (
                <LockBadge>
                    {lockImg ? (
                        <LockImg src={lockImg} alt="locked" />
                    ) : (
                        <LockCircle>
                            <AiOutlineLock size={28} />
                        </LockCircle>
                    )}
                </LockBadge>
            )}
        </FeatureCardRoot>
    );
}

const EduThumb = styled.div`
  position: absolute;
  right: -6px;
  bottom: -5px;
  border-radius: 10px;
  overflow: hidden;
  pointer-events: none;

  img {
    display: block;
    max-width: 160px;
    height: auto;
    object-fit: contain;
    transform: scale(${(p) => p.$scale || 1});
    transform-origin: bottom right;
    filter: ${(p) => (p.$disabled ? "grayscale(1)" : "none")};
    opacity: ${(p) => (p.$disabled ? 0.45 : 1)};
  }
`;

function EduCard({
    title,
    subtitle,
    onClick,
    img,
    tall,
    imgWidth,
    imgHeight,
    offsetX = 0,
    offsetY = 0,
    scale = 1,
    disabled = false,
    locked = false,
    lockImg,
}) {
    const w = imgWidth ?? (tall ? 116 : 68);
    const h = imgHeight ?? (tall ? 80 : 48);
    const rootDisabled = disabled || locked;

    return (
        <FeatureCardRoot
            onClick={onClick}
            $tall={tall}
            $disabled={rootDisabled}
            type="button"
        >
            <div className="title">{title}</div>
            {subtitle && <div className="subtitle">{subtitle}</div>}
            {img && (
                <EduThumb
                    $w={w}
                    $h={h}
                    $ox={offsetX}
                    $oy={offsetY}
                    $scale={scale}
                    $disabled={rootDisabled}
                >
                    <img src={img} alt="" />
                </EduThumb>
            )}
            {locked && (
                <LockBadge>
                    {lockImg ? (
                        <LockImg src={lockImg} alt="locked" />
                    ) : (
                        <LockCircle>
                            <AiOutlineLock size={28} />
                        </LockCircle>
                    )}
                </LockBadge>
            )}
        </FeatureCardRoot>
    );
}

const LocalThumb = styled.div`
  position: absolute;
  right: 5px;
  bottom: 5px;
  border-radius: 10px;
  overflow: hidden;
  pointer-events: none;

  img {
    display: block;
    max-width: 130px;
    height: auto;
    object-fit: contain;
    transform: scale(${(p) => p.$scale || 1});
    transform-origin: bottom right;
    filter: ${(p) => (p.$disabled ? "grayscale(1)" : "none")};
    opacity: ${(p) => (p.$disabled ? 0.45 : 1)};
  }
`;

function LocalCard({
    title,
    subtitle,
    onClick,
    img,
    tall,
    imgWidth,
    imgHeight,
    offsetX = 0,
    offsetY = 0,
    scale = 1,
    disabled = false,
    locked = false,
    lockImg,
}) {
    const w = imgWidth ?? (tall ? 116 : 68);
    const h = imgHeight ?? (tall ? 80 : 48);
    const rootDisabled = disabled || locked;

    return (
        <FeatureCardRoot
            onClick={onClick}
            $tall={tall}
            $disabled={rootDisabled}
            type="button"
        >
            <div className="title">{title}</div>
            {subtitle && <div className="subtitle">{subtitle}</div>}
            {img && (
                <LocalThumb
                    $w={w}
                    $h={h}
                    $ox={offsetX}
                    $oy={offsetY}
                    $scale={scale}
                    $disabled={rootDisabled}
                >
                    <img src={img} alt="" />
                </LocalThumb>
            )}
            {locked && (
                <LockBadge>
                    {lockImg ? (
                        <LockImg src={lockImg} alt="locked" />
                    ) : (
                        <LockCircle>
                            <AiOutlineLock size={28} />
                        </LockCircle>
                    )}
                </LockBadge>
            )}
        </FeatureCardRoot>
    );
}

function FeatureCard3({
    title,
    subtitle,
    onClick,
    img,
    tall,
    imgWidth,
    imgHeight,
    offsetX = 0,
    offsetY = 0,
    scale = 1,
    disabled = false,
    locked = false,
    lockImg,
}) {
    const w = imgWidth ?? (tall ? 116 : 68);
    const h = imgHeight ?? (tall ? 80 : 48);
    const rootDisabled = disabled || locked;

    return (
        <FeatureCardRoot
            onClick={onClick}
            $tall={tall}
            $disabled={rootDisabled}
            type="button"
        >
            <div className="title">{title}</div>
            {subtitle && <div className="subtitle">{subtitle}</div>}
            {img && (
                <Thumb3
                    $w={w}
                    $h={h}
                    $ox={offsetX}
                    $oy={offsetY}
                    $scale={scale}
                    $disabled={rootDisabled}
                >
                    <img src={img} alt="" />
                </Thumb3>
            )}
            {locked && (
                <LockBadge>
                    {lockImg ? (
                        <LockImg src={lockImg} alt="locked" />
                    ) : (
                        <LockCircle>
                            <AiOutlineLock size={28} />
                        </LockCircle>
                    )}
                </LockBadge>
            )}
        </FeatureCardRoot>
    );
}

/* ===== Wide list & card (styled) ===== */
const WideList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin-top: 12px;
`;

const WideCardRoot = styled.button`
  position: relative;
  width: 100%;
  padding: 16px;
  border: none;
  border-radius: 16px;
  background: ${(p) => (p.$disabled ? "#f3f4f6" : "#fff")};
  box-shadow: ${(p) =>
        p.$disabled ? "none" : "0 1px 6px rgba(0, 0, 0, 0.05)"};
  cursor: pointer;
  text-align: left;
  min-height: 138px;
  overflow: hidden;
  color: inherit;

  &:active {
    transform: translateY(1px);
  }
  &:hover {
    background: ${(p) => (p.$disabled ? "#f3f4f6" : "#f9fafb")};
    color: inherit;
  }

  .title {
    font-size: 18px;
    font-weight: 800;
    color: ${(p) => (p.$disabled ? "#9ca3af" : "#111")};
    letter-spacing: -0.2px;
  }
  .subtitle {
    margin-top: 6px;
    font-size: 14px;
    line-height: 1.35;
    color: ${(p) => (p.$disabled ? "#cbd5e1" : "#9aa0a6")};
    font-weight: 500;
    white-space: pre-line;
  }
`;

function WideCard({
    title,
    subtitle,
    onClick,
    img,
    imgWidth = 140,
    imgHeight = 100,
    offsetX = 0,
    offsetY = 0,
    disabled = false,
}) {
    return (
        <WideCardRoot onClick={onClick} $disabled={disabled} type="button">
            <div className="title">{title}</div>
            <div className="subtitle">{subtitle}</div>
            {img && (
                <Thumb2 $w={imgWidth} $h={imgHeight} $ox={offsetX} $oy={offsetY}>
                    <img src={img} alt="" />
                </Thumb2>
            )}
        </WideCardRoot>
    );
}

/* ===== Fallback 하드코드 ===== */
const FALLBACK = {
    hero: {
        slides: [],
        autoplayMs: 6000,
    },
    // 🔹 빠른 액션 6개 — 세무/법무까지 포함
    quickActions: [
        {
            title: "가맹 가입신청",
            subtitle: "파트너 등록하고\n서비스 시작할 때",
            img: imageDB.car,
            route: "/franchise/apply",
            lockEnabled: false,
            lockMessage: "",
            lockIconImg: "",
        },
        {
            title: "매출내역 / 랭킹",
            subtitle: "매출 현황 확인하고\n순위 비교할 때",
            img: imageDB.ranking,
            route: "/sales/ranking",
            lockEnabled: false,
            lockMessage: "",
            lockIconImg: "",
        },
        {
            title: "교육센터",
            subtitle: "서비스 가이드와\n교육 자료 볼 때",
            img: imageDB.education,
            route: "/edu",
            lockEnabled: false,
            lockMessage: "",
            lockIconImg: "",
        },
        {
            title: "로컬 제휴 서비스",
            subtitle: "지역 제휴 혜택을\n이용하고 싶을 때",
            img: imageDB.localservice,
            route: "/local/affiliates",
            lockEnabled: false,
            lockMessage: "",
            lockIconImg: "",
        },
        {
            title: "세무자료 센터",
            subtitle: "부가세·종소세 신고를 위한\n자료를 확인할 때",
            img: imageDB.notice,
            route: "/tax-center",
            lockEnabled: false,
            lockMessage: "",
            lockIconImg: "",
        },
        {
            title: "법률·세무 센터",
            subtitle: "택시 가맹 관련 법률·세무 상담을 한 곳에서",
            img: imageDB.notice,
            route: "/law-tax",
            lockEnabled: true,
            lockMessage:
                "법률·세무 센터는 기능 준비 중입니다.\n추후 오픈 예정입니다.",
            lockIconImg: "",
        },
    ],
    // 🔹 하단 와이드 리스트 — 쇼핑몰 / 공지사항
    sections: [
        {
            type: "wideList",
            items: [
                {
                    title: "쇼핑몰",
                    subtitle: "필수 용품과 상품을 한 번에 구매할 때",
                    img: imageDB.shopping,
                    route: "/mall",
                },
                {
                    title: "공지사항",
                    subtitle: "서비스 업데이트와 주요 소식을 확인할 때",
                    img: imageDB.notice,
                    route: "/notice",
                },
            ],
        },
    ],
};

// 홈 설정 캐시 키
const HOME_CFG_LS_KEY = "dhm.homeConfig.v1";

/* ===== 유틸: 발행본(published) → 화면 데이터 병합 ===== */
function mergeConfig(published) {
    if (!published) return FALLBACK;

    const heroSlides = (published.hero?.slides || []).length
        ? published.hero.slides
        : FALLBACK.hero.slides;

    // quickActions: 기본 6개 기준, 인덱스별 merge
    const fbQA = FALLBACK.quickActions || [];
    const pubQA = published.quickActions || [];
    const qa = fbQA.map((base, idx) => {
        const p = pubQA[idx] || {};
        return {
            ...base,
            ...p,
            title: p.title ?? base.title,
            subtitle: p.subtitle ?? base.subtitle,
            img: p.img || base.img,
        };
    });

    // wideList: 쇼핑몰/공지 2개만 merge
    const fbSec = FALLBACK.sections[0];
    const pubWide =
        (published.sections || []).find((s) => s.type === "wideList") || {};
    const pubItems = pubWide.items || [];
    const items = fbSec.items.map((base, idx) => {
        const p = pubItems[idx] || {};
        return {
            ...base,
            ...p,
            title: p.title ?? base.title,
            subtitle: p.subtitle ?? base.subtitle,
            img: p.img || base.img,
        };
    });

    return {
        hero: {
            slides: heroSlides,
            autoplayMs: published.hero?.autoplayMs ?? FALLBACK.hero.autoplayMs,
        },
        quickActions: qa,
        sections: [{ type: "wideList", items }],
    };
}
// ==== 버전 관리 유틸 ====





export default function HomePage() {
    const navigate = useNavigate();
    const go = (to) => navigate(to);

    // AppConfig 접근관리
    const { config } = useAppConfig();
    const accessCfg = config.access || {};

    // 접근관리 키별 가드 설정 (AdminAccessControl에서 관리)
    const guardFranchise = accessCfg.franchiseApply || {};
    const guardMySales = accessCfg.mySales || {};
    const guardEducation = accessCfg.education || {};
    const guardLocal = accessCfg.localService || {};
    const guardTaxCenter = accessCfg.taxCenter || {};
    const guardLawTax = accessCfg.lawTax || {};
    const guardMall = accessCfg.mall || {};
    const guardNotice = accessCfg.notice || {};

    const { loading, status, grade, memberType, refresh } = useDriverStatusContext();

    const [updating, setUpdating] = useState(false);


    useEffect(() => {
        let cancelled = false;

        checkAndApplyAppUpdate({
            onUpdateStart: (flag) => {
                if (cancelled) return;
                setUpdating(flag);
            },
        });

        return () => {
            cancelled = true;
        };
    }, []);

    const getSession = () => {
        try {
            return JSON.parse(localStorage.getItem("dhm.session") || "null");
        } catch {
            return null;
        }
    };

    // auth가 "user" 이거나 "member" 면 로그인 상태로 인정
    const isGuestSession = (s) =>
        !s || (s.auth !== "user" && s.auth !== "member");




    const session = getSession();
    const isGuest = isGuestSession(session);

    

    // 매출/교육에서 사용하는 멤버 기준
    const isSalesAllowed = status === "member" && grade !== "guest";

    const [ensuredStatus, setEnsuredStatus] = useState(false);

    // 홈 설정 (배너/카피 등) — 캐시 + 서버 병행
    const [cfg, setCfg] = useState(() => {
        if (typeof window === "undefined") return FALLBACK;
        try {
            const raw = localStorage.getItem(HOME_CFG_LS_KEY);
            if (!raw) return FALLBACK;
            const parsed = JSON.parse(raw);
            if (!parsed || !parsed.hero || !parsed.quickActions) return FALLBACK;
            return parsed;
        } catch {
            return FALLBACK;
        }
    });



    
    useEffect(() => {
        let alive = true;

        const addBust = (slides) =>
            (slides || []).map((s) =>
                s?.img
                    ? {
                        ...s,
                        img:
                            s.img +
                            (s.img.includes("?") ? "&" : "?") +
                            "v=" +
                            Date.now(),
                    }
                    : s
            );

        (async () => {
            try {
                const pub = await getPublishedOnce();
                if (!alive || !pub) return;

                const merged = mergeConfig(pub);
                merged.hero.slides = addBust(merged.hero.slides);

                setCfg(merged);

                try {
                    localStorage.setItem(HOME_CFG_LS_KEY, JSON.stringify(merged));
                } catch (e) {
                    console.warn("[Home] cache save failed:", e);
                }
            } catch (e) {
                console.error("[Home] load published failed:", e);
            }
        })();


        return () => {
    
            alive = false;
        };
    }, []);

    useEffect(() => {
        if (ensuredStatus) return;

        const sess = getSession();
        const isMemberSession =
            sess && (sess.auth === "member" || sess.auth === "user");

        // 🔥 세션은 멤버인데, driverStatus가 아직 member로 안 올라와 있으면 한 번만 refresh
        if (isMemberSession && !loading && status !== "member") {
            console.log("[HomePage] ensure driverStatus refresh", {
                status,
                grade,
                sess,
            });
            try {
                refresh();
            } catch (e) {
                console.warn("[HomePage] driverStatus refresh failed", e);
            }
            setEnsuredStatus(true);
        }
    }, [loading, status, grade, ensuredStatus]);

    // Hero 슬라이더 동작
    const [index, setIndex] = useState(0);
    const [anim, setAnim] = useState(true);
    const startX = useRef(0);
    const deltaX = useRef(0);
    const dragging = useRef(false);

    const slides = cfg.hero.slides || [];
    const clamp = (n) => Math.max(0, Math.min(slides.length - 1, n));

    const onTouchStart = (e) => {
        if (!slides.length) return;
        dragging.current = true;
        setAnim(false);
        startX.current = e.touches[0].clientX;
        deltaX.current = 0;
    };

    const onTouchMove = (e) => {
        if (!dragging.current || !slides.length) return;
        deltaX.current = e.touches[0].clientX - startX.current;
    };

    const onTouchEnd = (e) => {
        if (!slides.length) return;
        dragging.current = false;
        setAnim(true);
        const w = e.currentTarget.clientWidth || 1;
        const threshold = Math.min(60, w * 0.12);

        let next = index;
        if (deltaX.current <= -threshold) {
            next = clamp(index + 1);
        } else if (deltaX.current >= threshold) {
            next = clamp(index - 1);
        }
        setIndex(next);
        deltaX.current = 0;
    };

    useEffect(() => {
        if (!slides.length) return;

        const delay = cfg.hero.autoplayMs || 6000;

        const timer = setTimeout(() => {
            if (dragging.current) return;
            setIndex((prev) => (slides.length ? (prev + 1) % slides.length : 0));
        }, delay);

        return () => clearTimeout(timer);
    }, [index, slides.length, cfg.hero.autoplayMs]);

    const handleHeroClick = () => {
        const slide = slides[index];
        if (!slide) return;

        if (slide.noticeId) {
            navigate(`/notice/${slide.noticeId}`);
            return;
        }

        if (slide.route) {
            navigate(slide.route);
            return;
        }

        if (slide.href) {
            window.open(slide.href, "_blank");
        }
    };

    const qa = cfg.quickActions || FALLBACK.quickActions;

    // 1차 락(홈 설정 lockEnabled) → 2차 가드(접근관리) 순서
    const handleQuickClick = (idx, guardHandler) => () => {
        const item = qa[idx];
        if (!item) return;

        if (item.lockEnabled) {
            const msg =
                item.lockMessage ||
                `${item.title || "해당 메뉴"}는 현재 이용이 제한되어 있습니다.\n관리자에게 문의해 주세요.`;
            window.alert(msg);
            return;
        }

        guardHandler();
    };

    // 공통: 메시지 헬퍼
    const showGuardMessage = (message, fallback) => {
        window.alert(message || fallback);
    };

    /* ===== 2차 가드: 접근관리(config.access) 적용 ===== */

    // 0. 가맹 가입신청
    const guardFranchiseApply = (to) => {
        if (!guardFranchise.enabled) {
            navigate(to);
            return;
        }
        if (isGuest) {
            showGuardMessage(
                guardFranchise.message,
                "가맹 가입신청은 로그인 후 이용 가능합니다.\n자세한 문의는 본사로 연락해 주세요."
            );
            return;
        }
        navigate(to);
    };

    // 1. 매출/랭킹
    const guardSales = (to) => {
        if (!guardMySales.enabled) {
            navigate(to);
            return;
        }

        if (!isSalesAllowed || isGuest) {
            showGuardMessage(
                guardMySales.message,
                "로그인 후 승인 완료 시 이용 가능합니다.\n승인까지 1~2일 정도 소요될 수 있습니다."
            );
            return;
        }

        navigate(to);
    };

    // 2. 교육센터
    const guardEdu = (to) => {
        if (!guardEducation.enabled) {
            navigate(to);
            return;
        }

        // 교육센터는 멤버 + 등급 있는 기사만
        if (!isSalesAllowed || isGuest) {
            showGuardMessage(
                guardEducation.message,
                "교육센터는 가맹 기사만 이용 가능합니다.\n관리자에게 문의해 주세요."
            );
            return;
        }

        navigate(to);
    };

    // 3. 로컬 제휴 서비스
    const guardLocalService = (to) => {
        if (!guardLocal.enabled) {
            navigate(to);
            return;
        }

        if (isGuest) {
            showGuardMessage(
                guardLocal.message,
                "로컬 제휴 서비스는 로그인 후 이용 가능합니다.\n가맹 회원에게만 제공되는 서비스일 수 있습니다."
            );
            return;
        }

        navigate(to);
    };

    // 4. 세무자료 센터
    const guardTax = (to) => {
        if (!guardTaxCenter.enabled) {
            // 가드 OFF면 모두 허용
            navigate(to);
            return;
        }

        // 기본 정책: 개인택시 가맹 기사만
        if (isGuest || status !== "member" || memberType !== "personal") {
            showGuardMessage(
                guardTaxCenter.message,
                "세무자료 센터는 개인택시 가맹 기사만 이용 가능합니다.\n관리자에게 문의해 주세요."
            );
            return;
        }

        navigate(to);
    };

    // 5. 법률·세무 센터
    const guardLawTaxCenter = (to) => {
        if (!guardLawTax.enabled) {
            navigate(to);
            return;
        }

        if (isGuest) {
            showGuardMessage(
                guardLawTax.message,
                "법률·세무 센터는 로그인 후 이용 가능합니다.\n회원 전용 서비스일 수 있습니다."
            );
            return;
        }

        navigate(to);
    };

    // 쇼핑몰
    const guardMallRoute = (to) => {
        if (!guardMall.enabled) {
            navigate(to);
            return;
        }

        if (isGuest) {
            showGuardMessage(
                guardMall.message,
                "쇼핑몰은 로그인 후 이용 가능합니다."
            );
            return;
        }

        navigate(to);
    };

    // 공지사항
    const guardNoticeRoute = (to) => {
        if (!guardNotice.enabled) {
            navigate(to);
            return;
        }

        if (isGuest) {
            showGuardMessage(
                guardNotice.message,
                "공지사항은 로그인 후 확인할 수 있습니다."
            );
            return;
        }

        navigate(to);
    };

    const slidesExists = slides && slides.length > 0;

    return (
        <BG>
            <Header />
            <Container noPadding full>
                {/* Hero */}
                <HeroWrap
                    onTouchStart={onTouchStart}
                    onTouchMove={onTouchMove}
                    onTouchEnd={onTouchEnd}
                >
                    <Track data-track $index={index} $anim={anim}>
                        {slides.map((s, i) => (
                            <Slide key={i} onClick={handleHeroClick}>
                                <img
                                    src={s.img}
                                    alt={`banner-${i + 1}`}
                                    referrerPolicy="no-referrer"
                                />
                            </Slide>
                        ))}
                    </Track>
                    <HeroGradient />
                    {slidesExists && slides[index] && (
                        <HeroText>
                            <h1>{slides[index].title || ""}</h1>
                            <p>{slides[index].subtitle || ""}</p>
                        </HeroText>
                    )}
                    <Dots>
                        {slides.map((_, i) => (
                            <Dot key={i} $active={i === index} />
                        ))}
                    </Dots>
                </HeroWrap>

                {/* 빠른 액션 */}
                <TopSheet>
                    <Grabber />
                    {/* <SectionTitle>빠른 액션</SectionTitle> */}

                    <FeatureGrid>
                        {/* 0: 가맹 가입 */}
                        <FeatureCard
                            title={qa[0].title}
                            subtitle={qa[0].subtitle}
                            onClick={handleQuickClick(0, () =>
                                guardFranchiseApply("/franchise/apply")
                            )}
                            img={imageDB.car}
                            tall
                            imgWidth={116}
                            imgHeight={80}
                            offsetX={-6}
                            offsetY={4}
                            locked={!!qa[0].lockEnabled}
                            lockImg={qa[0].lockIconImg}
                        />

                        {/* 1: 매출 내역 / 랭킹 */}
                        <FeatureCard
                            title={qa[1].title}
                            subtitle={qa[1].subtitle}
                            onClick={handleQuickClick(1, () =>
                                guardSales("/sales/ranking")
                            )}
                            img={imageDB.ranking}
                            tall
                            imgWidth={116}
                            imgHeight={80}
                            offsetX={-6}
                            offsetY={2}
                            locked={!!qa[1].lockEnabled}
                            lockImg={qa[1].lockIconImg}
                        />

                        {/* 2: 교육센터 */}
                        <EduCard
                            title={qa[2].title}
                            subtitle={qa[2].subtitle}
                            onClick={handleQuickClick(2, () => guardEdu("/edu"))}
                            img={imageDB.education}
                            tall
                            offsetX={-6}
                            offsetY={2}
                            locked={!!qa[2].lockEnabled}
                            lockImg={qa[2].lockIconImg}
                        />

                        {/* 3: 로컬 제휴 서비스 */}
                        <LocalCard
                            title={qa[3].title}
                            subtitle={qa[3].subtitle}
                            onClick={handleQuickClick(3, () =>
                                guardLocalService("/local/affiliates")
                            )}
                            img={imageDB.localservice}
                            tall
                            offsetX={-6}
                            offsetY={2}
                            locked={!!qa[3].lockEnabled}
                            lockImg={qa[3].lockIconImg}
                        />

                        {/* 4: 세무자료 센터 */}
                        <FeatureCard3
                            title={qa[4].title}
                            subtitle={qa[4].subtitle}
                            onClick={handleQuickClick(4, () =>
                                guardTax("/tax-center")
                            )}
                            img={qa[4].img}
                            tall
                            imgWidth={116}
                            imgHeight={80}
                            offsetX={-6}
                            offsetY={4}
                            locked={!!qa[4].lockEnabled}
                            lockImg={qa[4].lockIconImg}
                        />

                        {/* 5: 법률·세무 센터 */}
                        <FeatureCard3
                            title={qa[5].title}
                            subtitle={qa[5].subtitle}
                            onClick={handleQuickClick(5, () =>
                                guardLawTaxCenter("/advisory")
                            )}
                            img={qa[5].img}
                            tall
                            imgWidth={116}
                            imgHeight={80}
                            offsetX={-6}
                            offsetY={4}
                            locked={!!qa[5].lockEnabled}
                            lockImg={qa[5].lockIconImg}
                        />
                    </FeatureGrid>

                    {/* 하단 와이드 리스트: 쇼핑몰 / 공지 */}
                    <WideList>
                        <WideCard
                            title={cfg.sections[0].items[0].title}
                            subtitle={cfg.sections[0].items[0].subtitle}
                            onClick={() => guardMallRoute("/mall")}
                            img={cfg.sections[0].items[0].img}
                            imgWidth={256}
                            imgHeight={168}
                            offsetX={36}
                            offsetY={-15}
                        />
                        <WideCard
                            title={cfg.sections[0].items[1].title}
                            subtitle={cfg.sections[0].items[1].subtitle}
                            onClick={() => guardNoticeRoute("/notice")}
                            img={cfg.sections[0].items[1].img}
                            imgWidth={240}
                            imgHeight={168}
                            offsetX={36}
                            offsetY={-15}
                        />
                    </WideList>
                </TopSheet>
            </Container>
  
            <FooterCompanyInfo />
            {updating && (
                <div
                    style={{
                        position: "fixed",
                        left: 0,
                        right: 0,
                        bottom: 56, // BottomNav 위 정도
                        zIndex: 9999,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        gap: 8,
                        padding: "8px 12px",
                        background: "rgba(15,23,42,0.96)",
                        color: "#f9fafb",
                        fontSize: 13,
                    }}
                >
                    <div
                        style={{
                            width: 16,
                            height: 16,
                            borderRadius: "999px",
                            border: "2px solid rgba(248,250,252,0.4)",
                            borderTopColor: "#e5e7eb",
                            animation: "spin 0.7s linear infinite",
                        }}
                    />
                    <span>업데이트 중입니다. 잠시만 기다려 주세요…</span>
                </div>
            )}
            <BottomNav
                active="home"
                onChange={(k) => console.log("tab:", k)}
                navigate={(p) => navigate(p)}
            />

      
        </BG>
    );
}
